














































































import { Component, Prop, Vue } from 'vue-property-decorator';
import moment from 'moment';

@Component
export default class DepositForm extends Vue {
  @Prop() readonly banks!: Array<any>;

  public selectedBank: { bank: string; name: string; account_number: string } = {
    bank: '',
    name: '',
    // eslint-disable-next-line @typescript-eslint/camelcase
    account_number: '',
  };

  public amount: string = '';

  public slip: File|null = null;

  public date: number = new Date().getDate();

  public month: number = new Date().getMonth() + 1;

  public year: number = new Date().getFullYear();

  public hour: string = this.addZeroPrefix(new Date().getHours());

  public minute: string = this.addZeroPrefix(new Date().getMinutes());

  // eslint-disable-next-line class-methods-use-this
  get hours(): Array<string> {
    return Array.from({ length: 24 }, (_, i) => this.addZeroPrefix(i));
  }

  get minutes(): Array<string> {
    return Array.from({ length: 60 }, (_, i) => this.addZeroPrefix(i));
  }

  // eslint-disable-next-line class-methods-use-this
  addZeroPrefix(value: number): string {
    if (value < 10) {
      return `0${value}`;
    }
    return String(value);
  }

  onSelectFile(file: File|null) {
    console.log(file);
    this.slip = file;
  }

  getFormData(): FormData {
    const formData = new FormData();
    formData.append('to_bank', this.selectedBank.bank);
    formData.append('to_account_number', this.selectedBank.account_number);
    formData.append('amount', this.amount);
    const requestTime = `${this.year}-${this.addZeroPrefix(this.month)}-${this.addZeroPrefix(this.date)} ${this.hour}:${this.minute}`;
    formData.append('request_time', moment(requestTime).valueOf().toString());
    if (this.slip) {
      const { slip } = this;
      formData.append('slip', slip);
    }
    return formData;
  }

  resetFormData(): void {
    this.selectedBank = {
      bank: '',
      name: '',
      // eslint-disable-next-line @typescript-eslint/camelcase
      account_number: '',
    };
    this.amount = '';
    this.slip = null;
    this.onSelectFile(null);
    // this.date = new Date().getDate();
    // this.month = new Date().getMonth() + 1;
    // this.year = new Date().getFullYear();
    // this.hour = this.addZeroPrefix(new Date().getHours());
    // this.minute = this.addZeroPrefix(new Date().getMinutes());
  }
}
